"use strict";

angular.module("vendor")
.controller("PartnershipCandidateCustomersController", function($scope, $stateParams, $attrs, close) {
    this.candidateCustomers = $attrs.candidateCustomers;
    this.email = $attrs.email;
    this.validCustomers = [];
    this.existingPartnerships = [];
    var _this = this;
    angular.forEach($attrs.candidateCustomers, function(customer) {
        if (customer.is_current_partnership) {
            _this.optionSelected = _this.candidateCustomers[0].id;
            _this.validCustomers.push(customer);
        } else if (customer.has_partnership) {
            _this.existingPartnerships.push(customer);
        } else {
            _this.validCustomers.push(customer);
        }
    });

    if (!$stateParams.id) {
        this.showCreateProspect = true;
    }

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
    };

    this.save = function() {
        $scope.candidateCustomersForm.$setSubmitted();

        if ($scope.candidateCustomersForm.$valid) {
            this.close();
            close.apply(this, [this.optionSelected]);
        }
    };
    this.cancel = function() {
        this.close();
        close.apply(this, null);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/partnership-form/partnership-candidate-customers.modal.js
// module id = 901
// module chunks = 0